import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const RoomTimeExceptionsPage = lazy(() =>
  import("./RoomTimeExceptionsPage").then((module) => ({ default: module.RoomTimeExceptionsPage })),
);

export function RoomTimeExceptionsAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <RoomTimeExceptionsPage />
    </Suspense>
  );
}
